import { render, staticRenderFns } from "./GJgrowEventCreateBaseSetting.vue?vue&type=template&id=11423182&scoped=true&"
import script from "./GJgrowEventCreateBaseSetting.vue?vue&type=script&lang=ts&"
export * from "./GJgrowEventCreateBaseSetting.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11423182",
  null
  
)

export default component.exports